import { WebRequest } from 'framework-ui-components';

export const statiANF = ({ termine, codiceUfficio }) => WebRequest.get(
  `AssegnoNucleoFamiliare/Stati?termine=${termine}&codiceUfficio=${codiceUfficio}`,
);

export const eliminaDichiarazione = ({ anno, idDichiarazione }) => WebRequest.post(`AssegnoNucleoFamiliare/Elimina?iddichiarazione=${idDichiarazione}`);

export const duplicaDomandaANF = ({
  idDichiarazione, CodiceFiscale, CodiceUfficio, Tipo,
}) => WebRequest.post(`AssegnoNucleoFamiliare/CreaAnfDaReiezione?iddichiarazione=${idDichiarazione}&codiceFiscale=${CodiceFiscale}&codiceUfficio=${CodiceUfficio}&tipo=${Tipo}`);

export const creaOrdinario = ({
  anno,
  codiceUfficio,
  codiceFiscale,
  cognome,
  nome,
  dataInizio,
  dataFine,
}) => WebRequest.post(
  `AssegnoNucleoFamiliare/CreaOrdinario?anno=${anno}&codiceUfficio=${codiceUfficio}&codiceFiscale=${codiceFiscale}&cognome=${cognome}&nome=${nome}&dataInizio=${dataInizio}&dataFine=${dataFine}`,
);

export const verificaOrdinarioCreabile = ({
  anno, codiceFiscale, codiceUfficio, dataInizio, dataFine,
}) => WebRequest.post(
  `AssegnoNucleoFamiliare/VerificaOrdinarioCreabile?codicefiscale=${codiceFiscale}&codiceufficio=${codiceUfficio}&anno=${anno}&dataInizio=${dataInizio}&dataFine=${dataFine}`,
);

export const creaVariazione = ({
  anno,
  codiceUfficio,
  codiceFiscale,
  cognome,
  nome,
  dataInizio,
}) => WebRequest.post(
  `AssegnoNucleoFamiliare/CreaVariazione?anno=${anno}&codiceUfficio=${codiceUfficio}&codiceFiscale=${codiceFiscale}&cognome=${cognome}&nome=${nome}&dataInizio=${dataInizio}`,
);

export const modificaVariazione = ({ idDichiarazione, dataInizio }) => WebRequest.post(
  `AssegnoNucleoFamiliare/ModificaVariazione?iddichiarazione=${idDichiarazione}&dataInizio=${dataInizio}`,
);

export const verificaVariazioneCreabile = ({ anno, codiceFiscale, codiceUfficio }) => WebRequest.post(
  `AssegnoNucleoFamiliare/VerificaVariazioneCreabile?codicefiscale=${codiceFiscale}&codiceufficio=${codiceUfficio}&anno=${anno}`,
);

export const avviaStampa = ({ idDichiarazioni }) => WebRequest.post('AssegnoNucleoFamiliare/AvviaStampa', idDichiarazioni);

export const avviaImpostaStatoInLavorazione = ({ anno, idDichiarazioni }) => WebRequest.post(`AssegnoNucleoFamiliare/ImpostaStatoInLavorazione?anno=${anno}`, idDichiarazioni);

export const avviaImpostaStatoCompleta = ({ anno, idDichiarazioni }) => WebRequest.post(`AssegnoNucleoFamiliare/ImpostaStatoCompleta?anno=${anno}`, idDichiarazioni);

export const avviaTrasmissioneEPASA = ({ anno, idDichiarazioni }) => WebRequest.post(
  `AssegnoNucleoFamiliare/ImpostaStatoTrasmissioneEPASA?anno=${anno}`,
  idDichiarazioni,
);

export const ottieniDelegaPatronatoEPASA = ({ anno, idDichiarazioni }) => WebRequest.post(
  `AssegnoNucleoFamiliare/OttieniDelegaPatronatoEPASA?anno=${anno}`,
  idDichiarazioni,
);

export const visualizzaEsitoInvioINPS = (idDichiarazione, anno) => WebRequest.get('AssegnoNucleoFamiliare/DescrizioneEsitoInvioINPS', { idDichiarazione, anno });

export const visualizzaEsitiINPS = (idDichiarazione) => WebRequest.get('AssegnoNucleoFamiliare/DescrizioneEsitiINPS', { idDichiarazione });

export const cercaDichiarazioni = (codiceUfficio, stato, termine, anno) => WebRequest.get('AssegnoNucleoFamiliare/Cerca?$skip=0&$top=128', {
  codiceUfficio, stato, termine, anno,
});

export const getConfigurazione = () => WebRequest.get('AssegnoNucleoFamiliare/GetConfigurazione');
